import { rareEarth } from '~/scopes/campaign/data/metals/rare-earth'

import translations from './geopolitical.translations'
import type { Journey } from './types'

const t = translations

/**
 * Rare earths: capitals rather than a supply chain, so the stops carry the client's country
 * names — right up to the shop counter, which is a country too. Coordinates are invented and
 * the pins all carry the impact's own icon; see `.claude/rules/guided-mining.md`.
 */
export const geopoliticalJourney: Journey = {
  impact: 'geopolitical',
  label: t.label,
  metal: rareEarth,
  stops: [
    {
      slug: 'intro',
      label: t.introLabel,
      title: t.introTitle,
      body: t.introBody,
      bodyAfter: t.introBodyTwo,
      cta: t.introCta,
      location: {
        coordinates: [-51.72, 64.18],
        zoom: 7,
      },
    },
    {
      slug: 'greenland',
      label: t.greenlandLabel,
      title: t.greenlandTitle,
      place: t.greenlandPlace,
      body: t.greenlandBody,
      citations: [2],
      cta: t.greenlandCta,
      location: {
        coordinates: [-51.72, 64.18],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'china',
      label: t.chinaLabel,
      title: t.chinaTitle,
      place: t.chinaPlace,
      body: t.chinaBody,
      citations: [1, 4, 8],
      cta: t.chinaCta,
      location: {
        coordinates: [116.41, 39.9],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'australia',
      label: t.australiaLabel,
      title: t.australiaTitle,
      place: t.australiaPlace,
      body: t.australiaBody,
      citations: [6],
      cta: t.australiaCta,
      location: {
        // Canberra. (Superseded: Sydney, which is not the capital the copy names.)
        coordinates: [149.13, -35.28],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'congo',
      label: t.congoLabel,
      title: t.congoTitle,
      place: t.congoPlace,
      body: t.congoBody,
      citations: [5, 7],
      cta: t.congoCta,
      location: {
        coordinates: [15.31, -4.32],
        zoom: 9,
        pin: true,
      },
    },
    {
      slug: 'ukraine',
      label: t.ukraineLabel,
      title: t.ukraineTitle,
      place: t.ukrainePlace,
      body: t.ukraineBody,
      citations: [3],
      cta: t.ukraineCta,
      location: {
        coordinates: [30.52, 50.45],
        zoom: 9,
        pin: true,
      },
    },
    {
      // The last stop, so its CTA finishes into the metal's extended reader.
      slug: 'sale',
      label: t.saleLabel,
      title: t.saleTitle,
      place: t.salePlace,
      body: t.saleBody,
      cta: t.saleCta,
      location: {
        // Apple Regent Street.
        coordinates: [-0.141, 51.5136],
        zoom: 9,
        pin: true,
      },
    },
  ],
}
